/**
 * The Event Archive (spec: docs/superpowers/specs/2026-10-04-archive-and-skip-design.md).
 *
 * Every event that has run before, replayable from the light-blue star under
 * the Update Log. Only the event's MINIGAME comes back — never its shop, its
 * capsule or its currency — and it pays an archive prize instead of the
 * event's own coin. Pure: the scenes read this list and nothing else decides
 * what the archive holds.
 */

export interface ArchivedEvent {
  /** Stable id; also the minigame board's kind on the server. */
  id: 'capyrun';
  /** The event's name, as it was billed while it ran. */
  title: string;
  /** What you actually get to play. */
  subtitle: string;
  /** A sprite the game already ships, for the row's thumbnail. */
  art: string;
  /** What finishing a run pays here (in place of the event's own currency). */
  prize: string;
  /** The prize's sprite. */
  prizeArt: string;
}

/** Oldest first, the order the archive lists them. */
export const ARCHIVED_EVENTS: readonly ArchivedEvent[] = [
  {
    id: 'capyrun',
    title: 'The Capybara Event',
    subtitle: 'Capy Run: tap capybaras, dodge the red imposters',
    art: 'capy-run-1',
    prize: 'Finish a run to earn a Capystone',
    prizeArt: 'item-capystone',
  },
];

/** Capystones paid for one finished archive Capy Run (LEAVE pays nothing). */
export const CAPYSTONES_PER_RUN = 1;
